import type * as Types from 'app/types/graphql';

export type CouponSelectFragment = Pick<Types.Coupon, 'id' | 'code'> & {
  promotion?: Types.Maybe<
    Pick<
      Types.Promotion,
      | 'id'
      | 'name'
      | 'type'
      | 'priority'
      | 'discountAmount'
      | 'discountUnit'
      | 'conditions'
      | 'startDate'
      | 'endDate'
      | 'enableForAllPlans'
    > & { plans?: Types.Maybe<Array<Pick<Types.Plan, 'id' | 'name'>>> }
  >;
};

export type CouponEdgeSelectFragment = Pick<Types.CouponEdge, 'cursor'> & {
  node?: Types.Maybe<
    Pick<Types.Coupon, 'id' | 'code'> & {
      promotion?: Types.Maybe<
        Pick<
          Types.Promotion,
          | 'id'
          | 'name'
          | 'type'
          | 'priority'
          | 'discountAmount'
          | 'discountUnit'
          | 'conditions'
          | 'startDate'
          | 'endDate'
          | 'enableForAllPlans'
        > & { plans?: Types.Maybe<Array<Pick<Types.Plan, 'id' | 'name'>>> }
      >;
    }
  >;
};

export const CouponSelectFragmentDoc = `
    fragment CouponSelect on Coupon {
  id
  code
  promotion {
    ...PromotionSelect
  }
}
    `;
export const CouponEdgeSelectFragmentDoc = `
    fragment CouponEdgeSelect on CouponEdge {
  cursor
  node {
    ...CouponSelect
  }
}
    `;
